import {
  EmploymentType,
  JobPostingType,
  PooledPostingType,
} from "@nimble/data-service-client/types";
import z from "zod";

export const JobPostingSchema = z.object({
  employment_type: z.enum(EmploymentType).nullable(),
  job_url: z.url(),
  job_description: z.string().nullable(),
  pooled_posting_type: z.enum(PooledPostingType).nullable(),
  posting_type: z.enum(JobPostingType),
  subcategories: z.array(z.string()),
  title: z.string(),
  uuid: z.string(),
  ats_job_id: z.string().nullable(),
  salary_min: z.number().nullable(),
  salary_max: z.number().nullable(),
  is_internal: z.boolean(),
  district_nces_id: z.string().nullable(),
  date_posted: z.string().nullable(),
  created_at: z.string(),
});

export type JobPosting = z.infer<typeof JobPostingSchema>;

export const JobPostingCardDataSchema = z.object({
  uuid: z.string(),
  title: z.string(),
  subcategories: z.array(z.string()),
  pooled_posting_type: z.enum(PooledPostingType).nullable(),
  date_posted: z.string().nullable(),
  created_at: z.string(),
  salary_min: z.number().nullable(),
  salary_max: z.number().nullable(),
  employment_type: z.enum(EmploymentType).nullable(),
});

export type JobPostingCardData = z.infer<typeof JobPostingCardDataSchema>;
